import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'

interface TimelineProps {
  title: string
  titleEn?: string
  items: Array<{
    year: string
    title: string
    titleEn?: string
    description: string
    descriptionEn?: string
  }>
}

export default function TimelineBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as TimelineProps

  const items = p.items || []

  if (items.length === 0 && !p.title && !p.titleEn) return null

  return (
    <section className="py-20 px-6">
      <div className="max-w-3xl mx-auto">
        {(p.title || p.titleEn) && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {lang === 'en' && p.titleEn ? p.titleEn : p.title}
          </h2>
        )}
        <div className="relative">
          {items.length > 0 && (
            <div className="absolute left-[19px] top-0 bottom-0 w-[2px]"
              style={{ background: `linear-gradient(to bottom, ${branding.primaryColor}60, ${branding.primaryColor}20)` }} />
          )}
          <div className="space-y-6">
            {items.map((item, i) => (
              <div key={i} className="flex items-start gap-4">
                <div className="relative z-10 h-10 w-10 rounded-full bg-white border-2 flex items-center justify-center shrink-0"
                  style={{ borderColor: branding.primaryColor }}>
                  <span className="text-[10px] font-bold" style={{ color: branding.primaryColor }}>{item.year?.slice(-2)}</span>
                </div>
                <div className="pt-1.5">
                  <h3 className="text-sm font-bold mb-0.5" style={{ color: branding.secondaryColor }}>
                    {lang === 'en' && item.titleEn ? item.titleEn : item.title}
                  </h3>
                  <p className="text-xs text-gray-400 leading-relaxed">
                    {lang === 'en' && item.descriptionEn ? item.descriptionEn : item.description}
                  </p>
                  <span className="text-[10px] text-gray-300">{item.year}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
